var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"Group"},[_c('ui-sidebar'),_vm._v(" "),_c('div',{staticClass:"rightBox clearfix"},[_c('ui-topbar',{staticClass:"d-none d-lg-block"}),_vm._v(" "),_c('router-view'),_vm._v(" "),_c('ui-footer')],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3c4c58bf","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/group/Group.vue
// module id = null
// module chunks = 